import React, { useContext } from "react";
import { Table } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import UnifyJobStore from "../../../app/stores/unifyjobsStore";
import { useEffect } from "react";

const EmployeeUnifyJobList: React.FC = () => {
  const unifyjobStore = useContext(UnifyJobStore);
  const { unifyjobnamesByDate } = unifyjobStore;


  return (
    <Table compact size="small" unstackable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Financial Year</Table.HeaderCell>
          <Table.HeaderCell>Pay Run</Table.HeaderCell>
          <Table.HeaderCell>Work Order ID</Table.HeaderCell>
          <Table.HeaderCell>Technician</Table.HeaderCell>
          <Table.HeaderCell>Start Date</Table.HeaderCell>
          <Table.HeaderCell>Hours</Table.HeaderCell>
          <Table.HeaderCell>SOR ID</Table.HeaderCell>
          <Table.HeaderCell>Work Order Lines Description</Table.HeaderCell>
          <Table.HeaderCell>Status</Table.HeaderCell>
          <Table.HeaderCell>Artefact Comments</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {unifyjobnamesByDate.map((unifyjob) => (
          <Table.Row key={unifyjob.id}>
            <Table.Cell>{unifyjob.financialYear}</Table.Cell>
            <Table.Cell>{unifyjob.payRun}</Table.Cell>
            <Table.Cell>{unifyjob.workOrderNumber}</Table.Cell>
            <Table.Cell>{unifyjob.tech}</Table.Cell>
            <Table.Cell>
              {unifyjob.startDate.substr(8, 2) +
                "/" +
                unifyjob.startDate.substr(5, 2) +
                "/" +
                unifyjob.startDate.substr(0, 4)}
            </Table.Cell>
            <Table.Cell>{unifyjob.hours}</Table.Cell>
            <Table.Cell>{unifyjob.sorId}</Table.Cell>
            <Table.Cell>{unifyjob.description}</Table.Cell>
            <Table.Cell>{unifyjob.status}</Table.Cell>
            <Table.Cell>{unifyjob.comment}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default observer(EmployeeUnifyJobList);
